module.exports = __webpack_public_path__ + "static/baratoLogo-95d46ca308d011e63ee38d284b8eda86.svg";